import React, { useState } from "react";

// ASSETS
import searchIcon from "assets/svg/SearchIcon.svg";
import searchIconSelected from "assets/svg/SearchIconSelected.svg";
import gptIcon from "assets/svg/GptIcon.svg";
import hamburgerMenuIcon from "assets/svg/HamburgerMenuIcon.svg";
import hamburgerMenuIconSelected from "assets/svg/HamburgerMenuIconSelected.svg";

// STYLES
import { MobileHeaderContainer } from "./MobileHeaderAtomStyled";

// LIBRARIES
import { useNavigate } from "react-router";
// MISC
import { IconButtonAtomProps } from "../IconButtonAtom/IconButtonAtomModel";
import { UIState } from "./MobileHeaderAtomModel";
// REDUX

// COMPONENTS
import IconButtonAtom from "../IconButtonAtom/IconButtonAtom";
import HamburgerMenuComponent from "components/HamburgerMenuComponent/HamburgerMenuComponent";

const MobileHeaderAtom = () => {
  // PROPERTIES

  // STATE CONSTANTS
  const [uiState, setUiState] = useState<UIState>({
    selectedIconIndex: null,
    isHamburgerMenuOpen: false,
  });
  const icons: IconButtonAtomProps = {
    id: 2,
    icon: hamburgerMenuIcon,
    isSelected: uiState.selectedIconIndex === 2,
    iconHovered: hamburgerMenuIconSelected,
    shouldNavigateOn: false,
  };

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleIconClick = (iconProps: IconButtonAtomProps) => {
    const newState = {
      selectedIconIndex: iconProps.id,
      isSearchBarOpen: iconProps.id === 1,
      isHamburgerMenuOpen: iconProps.id === 2,
    };
    setUiState(newState);
    if (iconProps.shouldNavigateOn) {
      navigate(iconProps.path);
    }
  };

  return (
    <>
      <MobileHeaderContainer>
        <IconButtonAtom
          desktop={false}
          key={icons.id}
          {...icons}
          isSelected={uiState.selectedIconIndex === icons.id}
          onClick={() => handleIconClick(icons)}
        />
      </MobileHeaderContainer>
      <HamburgerMenuComponent
        isOpen={uiState.isHamburgerMenuOpen}
        onOpen={() =>
          setUiState({
            selectedIconIndex: null,
            isHamburgerMenuOpen: false,
          })
        }
      />
    </>
  );
};

export default MobileHeaderAtom;
